import { render } from "./DynamicRadioButton.vue?vue&type=template&id=56d47bb4&ts=true"
import script from "./DynamicRadioButton.vue?vue&type=script&lang=ts"
export * from "./DynamicRadioButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicRadioButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56d47bb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56d47bb4', __exports__)) {
    api.reload('56d47bb4', __exports__)
  }
  
  module.hot.accept("./DynamicRadioButton.vue?vue&type=template&id=56d47bb4&ts=true", () => {
    api.rerender('56d47bb4', render)
  })

}


export default __exports__